<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>CAMPUS LIFE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Mess</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <h2 class="text-center">Our Mess</h2>
        <p>The University has two separate large Dining Halls for the Boy and Girl hostellers, connected with their
            Hostels to ensure their better time management and security. The menu is decided by the Mess Committee,
            comprising of students from all hostels and the Wardens. The Mess charges are paid in advance for whole
            Semester, in the beginning of each Semester along with other charges of the University.</p>
        <ul>
            <li>All seasonal vegtable are availble according to season</li>
        </ul>

        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/mess1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/mess2.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/mess3.jpg" class="cover-background w-100 h-100"/>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
                <img src="assets/img/hostel/mess4.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>
    </div>
</section>
